const ArrowRightIcon = ({
  width = '17',
  height = '16',
  fill = 'none',
  stroke,
  ...props
}: any) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 17 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M9.32035 4.66683L13.1665 8.00016M13.1665 8.00016L9.32035 11.3335M13.1665 8.00016L3.1665 8.00016'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ArrowRightIcon;
